import { render, staticRenderFns } from "./ClassPackageExpired.vue?vue&type=template&id=af243172&scoped=true&"
import script from "./ClassPackageExpired.vue?vue&type=script&lang=js&"
export * from "./ClassPackageExpired.vue?vue&type=script&lang=js&"
import style0 from "./ClassPackageExpired.vue?vue&type=style&index=0&id=af243172&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af243172",
  null
  
)

export default component.exports